import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Users, Calendar, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  icon: React.ElementType;
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { icon: Home, label: 'Dashboard', path: '/instructor' },
  { icon: Users, label: 'Students', path: '/instructor/students' },
  { icon: Calendar, label: 'Calendar', path: '/instructor-calendar' },
  { icon: Settings, label: 'Settings', path: '/account-settings' }
];

export const InstructorBottomNav: React.FC = () => {
  const location = useLocation();
  
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-xl border-t border-border/70 shadow-[0_-4px_16px_-12px_rgba(15,23,42,0.35)] max-w-[100vw]"
      style={{ 
        paddingBottom: 'max(8px, env(safe-area-inset-bottom, 0px))',
        paddingLeft: 'env(safe-area-inset-left, 0px)',
        paddingRight: 'env(safe-area-inset-right, 0px)'
      }}
    >
      <div className="grid grid-cols-4 h-16 w-full mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "relative flex flex-col items-center justify-center gap-1 rounded-xl mx-1 my-1.5 transition-all duration-200",
                isActive ? "bg-primary/[0.08]" : "hover:bg-muted/40"
              )}
            >
              <Icon 
                className={cn(
                  "h-[19px] w-[19px] transition-colors duration-200",
                  isActive ? "text-primary" : "text-muted-foreground"
                )} 
                strokeWidth={isActive ? 2.2 : 1.8}
              />
              <span 
                className={cn(
                  "text-[10px] transition-colors duration-200",
                  isActive ? "text-primary font-semibold" : "text-muted-foreground font-medium"
                )}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};